import React from 'react';

import Configure from 'assets/unifiedCommunication/Configure.svg';
import Modal from 'common-ui/modal';
import MyCheckbox from 'common-ui/myCheckbox';
import { Table } from 'common-ui/table';

import {
  ChannelCell,
  ChannelColor,
  ConfigureDescription,
  ConfigureHeader,
  ConfigureIcon,
  ConfigureTitle,
} from './ChannelConfigurator.style';

const ChannelConfigurator = ({
  isOpen,
  onClose,
  role,
  channelPermissions,
  setChannelPermissions,
}) => {
  const channelList = [
    { id: 1, key: 'WhatsApp', name: 'WhatsApp', color: '#22C55E' },
    { id: 2, key: 'Viber', name: 'Viber', color: '#8B5CF6' },
    { id: 3, key: 'LinkedIn', name: 'LinkedIn', color: '#3B82F6' },
    { id: 4, key: 'TikTok', name: 'TikTok', color: '#000000' },
    { id: 5, key: 'Instagram', name: 'Instagram', color: '#EC4899' },
    { id: 6, key: 'Messenger', name: 'Messenger', color: '#3B82F6' },
  ];

  const handleChannelPermission = (channelId, type) => {
    setChannelPermissions((prev) => ({
      ...prev,
      [channelId]: type,
    }));
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      footer
      okText="Save Changes"
      cancelText="Cancel"
      onOk={onClose}
      width={'512px'}
      closeIcon
      className="custom-channel-modal"
    >
      <ConfigureHeader>
        <ConfigureIcon src={Configure} alt="configure" />
        <ConfigureTitle>Configure Channel Access</ConfigureTitle>
      </ConfigureHeader>
      <ConfigureDescription>
        Set channel-level permissions for communication window {role?.role}
      </ConfigureDescription>
      <Table
        pagination={false}
        data={channelList}
        columns={[
          {
            title: 'Channel',
            dataIndex: 'name',
            render: (value, row) => (
              <ChannelCell>
                <ChannelColor $color={row.color} />
                {value}
              </ChannelCell>
            ),
          },
          {
            title: 'None',
            render: (_, row) => (
              <MyCheckbox
                selected={channelPermissions[row.id] === 'none'}
                onClick={() => handleChannelPermission(row.id, 'none')}
              />
            ),
          },
          {
            title: 'View',
            render: (_, row) => (
              <MyCheckbox
                selected={channelPermissions[row.id] === 'view'}
                onClick={() => handleChannelPermission(row.id, 'view')}
              />
            ),
          },
          {
            title: 'View and Reply',
            render: (_, row) => (
              <MyCheckbox
                selected={channelPermissions[row.id] === 'reply'}
                onClick={() => handleChannelPermission(row.id, 'reply')}
              />
            ),
          },
        ]}
      />
    </Modal>
  );
};

export default ChannelConfigurator;
